import { Injectable } from "@angular/core";
import { environment } from "@env";
import { TranslateService } from "@ngx-translate/core";
import { Observable, map } from "rxjs";

@Injectable({
	providedIn: "root"
})
export class AutomataTranslateService {
	constructor(private translate: TranslateService) {}

	getTranslationSync(
		key: string,
		dynamicParams?: Record<string, string>
	): string {
		const translation = this.translate.instant(
			key,
			dynamicParams
		) as string;
		if (translation === key) {
			if (!environment.production) {
				console.error(`Translation not found for key: ${key}`);
			}
			return "";
		}
		return translation;
	}

	getTranslationAsync(
		key: string,
		dynamicParams?: Record<string, string>
	): Observable<string> {
		return this.translate.get(key, dynamicParams).pipe(
			map((translation) => translation as string),
			map((translation) => {
				if (translation === key) {
					if (!environment.production) {
						console.error(`Translation not found for key: ${key}`);
					}
					return "";
				}
				return translation;
			})
		);
	}
}
